import {env} from './env';

// Arc queries

export const AGENTS_LIST = `AGENTS_LIST${env}`;
export const AGENTS_LIST_COUNT = `AGENTS_LIST_COUNT${env}`;
export const BUYERS_LIST = `BUYERS_LIST${env}`;
export const BUYERS_LIST_COUNT = `BUYERS_LIST_COUNT${env}`;
export const BUYERS_LOCATION = `BUYERS_LOCATION${env}`;
export const BUYERS_LOCATION_TOTAL = `BUYERS_LOCATION_TOTAL${env}`;
export const ESCROW_TRACKING = `ESCROW_TRACKING${env}`;
export const ESCROW_TRACKING_LIST = `ESCROW_TRACKING_LIST${env}`;
export const FIRMS_LIST = `FIRMS_LIST${env}`;
export const FIRMS_LIST_COUNT = `FIRMS_LIST_COUNT${env}`;
export const GET_ALL_TENANTS = `GET_ALL_TENANTS${env}`;
export const GET_AGENT_GROSS_CUMULATIVE = `GET_AGENT_GROSS_CUMULATIVE${env}`;
export const HSC_AGENT_CUMULATIVE = `HSC_AGENT_CUMULATIVE${env}`;
export const GET_PAYMENT_PROPERTIES = `GET_PAYMENT_PROPERTIES${env}`
export const OA_AGENT_PIPELINE = `OA_AGENT_PIPELINE${env}`;
export const OLD_STRIVE_AGENT_PIPELINE = `OLD_STRIVE_AGENT_PIPELINE${env}`;
export const PROPERTIES_BY_BUYER_STATE = `PROPERTIES_BY_BUYER_STATE${env}`;
export const PROPERTY_UNDERWRITING_TENANTS = `PROPERTY_UNDERWRITING_TENANTS${env}`;
export const SELLERS_LIST = `SELLERS_LIST${env}`;
export const SELLERS_LIST_COUNT = `SELLERS_LIST_COUNT${env}`;
export const STRIVE_AGENT_PIPELINE = `STRIVE_AGENT_PIPELINE${env}`;
export const STRIVE_AGENT_PIPELINE_DETAILS = `STRIVE_AGENT_PIPELINE_DETAILS${env}`;
export const AGENT_COMMISSION_BREAKDOWN_PROCURED = `AGENT_COMMISSION_BREAKDOWN_PROCURED${env}`;
export const AGENT_COMMISSION_BREAKDOWN_PAID = `AGENT_COMMISSION_BREAKDOWN_PAID${env}`;
export const AGENT_COMMISSION_PROCURED = `AGENT_COMMISSION_PROCURED${env}`;
export const AGENT_COMMISSION_PAID = `AGENT_COMMISSION_PAID${env}`;
export const STRIVE_BUCKETS = `STRIVE_BUCKETS${env}`;
export const STRIVE_BUCKETS_DETAILS = `STRIVE_BUCKETS_DETAILS${env}`;
export const STRIVE_FEES = `STRIVE_FEES${env}`;
export const STRIVE_HISTORICAL_PIPELINE = `STRIVE_HISTORICAL_PIPELINE${env}`;
export const STRIVE_HISTORICAL_PIPELINE_SPLIT = `STRIVE_HISTORICAL_PIPELINE_SPLIT${env}`;
export const STRIVE_INVENTORY_V2 = `STRIVE_INVENTORY_V2${env}`;
export const STRIVE_INVENTORY_V3 = `STRIVE_INVENTORY_V3${env}`;
export const STRIVE_INVENTORY_BREAKDOWN_V1 = `STRIVE_INVENTORY_BREAKDOWN_V1${env}`;
export const STRIVE_PIPELINE_CLOSED = `STRIVE_PIPELINE_CLOSED${env}`;
export const STRIVE_PIPELINE_CLOSED_SPLIT = `STRIVE_PIPELINE_CLOSED_SPLIT${env}`;
export const STRIVE_PIPELINE_TRANSACTION_TYPE = `STRIVE_PIPELINE_TRANSACTION_TYPE${env}`;
export const STRIVE_PIPELINE_TRANSACTION_TYPE_SPLIT = `STRIVE_PIPELINE_TRANSACTION_TYPE_SPLIT${env}`;
export const STRIVE_PIPELINE_V2 = `STRIVE_PIPELINE_V2${env}`;
export const STRIVE_PIPELINE_V2_SPLIT = `STRIVE_PIPELINE_V2_SPLIT${env}`;
export const STRIVE_PIPELINE_BY_STATUS_AND_TRANSACTION_TYPE = `STRIVE_PIPELINE_BY_STATUS_AND_TRANSACTION_TYPE${env}`;
export const STRIVE_QUARTERLY_PIPELINE = `STRIVE_QUARTERLY_PIPELINE${env}`;
export const STRIVE_QUARTERLY_PIPELINE_SPLIT = `STRIVE_QUARTERLY_PIPELINE_SPLIT${env}`;
export const TENANTS_LIST = `TENANTS_LIST${env}`;
export const TENANTS_LIST_COUNT = `TENANTS_LIST_COUNT${env}`;
export const LENDERS_LIST = `LENDERS_LIST${env}`;
export const LENDERS_LIST_COUNT = `LENDERS_LIST_COUNT${env}`;
export const TEXAS_MARKET_TRANSACTIONS = `TEXAS_MARKET_TRANSACTIONS${env}`;
export const TEXAS_MARKET_SHARE = `TEXAS_MARKET_SHARE${env}`;
export const TEXAS_REGION_TRANSACTIONS = `TEXAS_REGION_TRANSACTIONS${env}`;
export const TEXAS_TOTAL_TRANSACTIONS = `TEXAS_TOTAL_TRANSACTIONS${env}`;
export const UNDERWRITING_TENANT_LIST = `UNDERWRITING_TENANT_LIST${env}`;
export const V7_PROPERTIES_LIST = `V7_PROPERTIES_LIST${env}`;
export const V8_PROPERTIES_LIST = `V8_PROPERTIES_LIST${env}`;
export const V7_ROPERTIES_LENDERLIST = `V7_ROPERTIES_LENDERLIST${env}`
export const V7_PROPERTIES_MAP = `V7_PROPERTIES_MAP${env}`;
export const V7_PROPERTIES_STATS = `V7_PROPERTIES_STATS${env}`;
export const V7_PROPERTIES_STATS_ACTIVE = `V7_PROPERTIES_STATS_ACTIVE${env}`;
export const V7_PROPERTIES_STATS_COUNT = `V7_PROPERTIES_STATS_COUNT${env}`;
export const PROPERTY_DATA = `PROPERTY_DATA${env}`;
export const STATS_BY_STATUS = `STATS_BY_STATUS${env}`;
export const STATS_BY_TYPE = `STATS_BY_TYPE${env}`;
export const STATS_BY_BUYER_STATE = `STATS_BY_BUYER_STATE${env}`;
export const HSC_PIPELINE = `HSC_PIPELINE${env}`;
export const HSC_PIPELINE_FEES = `HSC_PIPELINE_FEES${env}`;
export const HSC_TRACKING = `HSC_TRACKING${env}`;
export const HSC_TRACKING_LIST = `HSC_TRACKING_LIST${env}`;
export const GET_PROPERTY_HISTORY = `GET_PROPERTY_HISTORY${env}`;
export const PRIME_RATES = `Prime_rates${env}`;
export const PROPERTIES_ADDRESS = `PROPERTIES_ADDRESS${env}`;
export const STATS_BY_STATUS_HSC = `STATS_BY_STATUS_HSC${env}`;

export const TEAM_MEMBER_LIST = `TEAM_MEMBER_LIST${env}`;
export const TEAM_MEMBER_LIST_COUNT = `TEAM_MEMBER_LIST_COUNT${env}`;
export const STRIVE_AGENT_FIRST_CLOSING = `STRIVE_AGENT_FIRST_CLOSING${env}`;
export const STRIVE_AGENT_FIRST_LISTING = `STRIVE_AGENT_FIRST_LISTING${env}`;
export const AGENT_EMPLOYEE_LIST = 'AGENT_EMPLOYEE_LIST';
export const UNIQUE_TERRITORIES = `UNIQUE_TERRITORIES${env}`;

export const TEAM_MEMBERS_LIST = `TEAM_MEMBERS_LIST${env}`;
export const TEAM_MEMBERS_LIST_COUNT = `TEAM_MEMBERS_LIST_COUNT${env}`;
export const HSC_MEMBER_LISTING_CLOSING_DATES = `HSC_MEMBER_LISTING_CLOSING_DATES${env}`;
export const GET_YEARLY_TOTAL_COMMISSION = `GET_YEARLY_TOTAL_COMMISSION`;





// Arc email queries

export const JUST_LISTED_JUST_CLOSED_PROPERTY = `JUST_LISTED_JUST_CLOSED_PROPERTY${env}`;
export const NEGOTIATION_UNDER_CONTRACT_PROPERTY = `NEGOTIATION_UNDER_CONTRACT_PROPERTY${env}`;
export const PROPERTY_DATA_DEFAULT_EMAIL = `PROPERTY_DATA_DEFAULT_EMAIL${env}`;
export const GET_HSC_CLOSINGS = `GET_HSC_CLOSINGS${env}`;
export const GET_REFERRAL_CLOSINGS = `GET_REFERRAL_CLOSINGS${env}`;
export const GET_OFF_MARKET_SELLERS = `GET_OFF_MARKET_SELLERS${env}`;